import {
  BookOutlined,
  FileTextOutlined,
  TeamOutlined,
  UserOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import {
  CategoryFilter,
  CategoryMeta,
  ExcludeDomain,
} from '../../interfaces/global-search';
import {
  DOKUMENT,
  EKSPERT_TRAJNIMI,
  KONKURRENT,
  PJESEMARRES,
  TRAJNIM_PREZENCA,
  TRAJNIMI,
} from '../common/common-functions/common-functions';
import { SearchCategory } from '../../utilities/global-search-enums';

export const getCategoryMeta = (category = ''): CategoryMeta => {
  switch (category) {
    case PJESEMARRES:
      return {
        icon: <TeamOutlined />,
        label: 'Pjesëmarrës',
        color: '#1890ff',
      };

    case TRAJNIMI:
      return {
        icon: <BookOutlined />,
        label: 'Trajnime',
        color: '#52c41a',
      };

    case DOKUMENT:
      return {
        icon: <FileTextOutlined />,
        label: 'Dokument',
        color: '#fa8c16',
      };

    case EKSPERT_TRAJNIMI:
      return {
        icon: <UserOutlined />,
        label: 'Ekspert Trajnimi',
        color: '#722ed1',
      };

    case TRAJNIM_PREZENCA:
      return {
        icon: <CheckCircleOutlined />,
        label: 'Trajnim Prezenca',
        color: '#13c2c2',
      };

    default:
      return {
        icon: <FileTextOutlined />,
        label: category,
        color: '#1890ff',
      };
  }
};

export const normalizeApiKey = (key: string): SearchCategory | null => {
  const normalized = key.toLowerCase().trim();

  const exactMatch: Record<string, SearchCategory> = {
    dokumente: DOKUMENT,
    pjesmarres: PJESEMARRES,
    trajnimi: TRAJNIMI,
    ekspert_trajnimi: EKSPERT_TRAJNIMI,
    eksperttrajnimi: EKSPERT_TRAJNIMI,
    trajnim_prezenca: TRAJNIM_PREZENCA,
    trajnimprezenca: TRAJNIM_PREZENCA,
    konkurrent: KONKURRENT,
  };

  if (exactMatch[normalized]) {
    return exactMatch[normalized];
  }

  if (normalized.startsWith('dokument')) return DOKUMENT;
  if (
    normalized.startsWith('pjesmarres') ||
    normalized.startsWith('pjesemarres')
  ) {
    return PJESEMARRES;
  }
  if (normalized.startsWith('trajnim')) {
    if (normalized.includes('prezenca') || normalized.includes('prezence')) {
      return TRAJNIM_PREZENCA;
    }
    return TRAJNIMI;
  }
  if (normalized.startsWith('ekspert')) {
    return EKSPERT_TRAJNIMI;
  }

  if (key) {
    return key as SearchCategory;
  }

  return null;
};

const ALL_CATEGORIES = [
  DOKUMENT,
  TRAJNIMI,
  PJESEMARRES,
  EKSPERT_TRAJNIMI,
  TRAJNIM_PREZENCA,
];

export const initExclude: ExcludeDomain = {
  excludeSubModules: [],
};

export const getExcludeSearchDomain = (
  category: CategoryFilter,
): ExcludeDomain | undefined => {
  if (category === 'All') {
    return undefined;
  }

  const excludeList = ALL_CATEGORIES.filter(cat => cat !== category);

  return {
    excludeSubModules: excludeList,
  };
};
